import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Zone, BasicDetailConfig, validationForFields, Role, EMAIL_VALIDATION, defaultZone, EmploymentType, TENANT, TENANTS,Business, HRF_BUSINESS_VERTICAL_ID, Vertical, TOP_HIERARCHY_ROLE_ID, showPhSalesOfficerTaggingField, showPhSalesOfficerTaggingDisplay, getTaggingLabel } from '../../config/constant';
import MasterService from '../../services/MasterService';
import Loader from '../common/loader';
import { toast } from 'react-toastify';
import CbiCreditInformation from './CbiCreditInformation';
import HrfDocumentSection from './HrfDocumentSection';
import { isEmpty } from '../../config/helper';



const PreviewConfirm = (props) => {
    let { stateList, cityList, ConfigList, user_detail } = props
    const [roleList, setRoleDetails] = useState([])
    const [userDetail, setUserDetail] = useState(user_detail)
    const [reportingRoleList, setReportingRoleList] = useState([])
    const [ReferralName, setReferralName] = useState([])
    const [reportingManagerList, setReportingManagerList] = useState([])
    const [secondaryReportingRoleList, setSecondaryReportingRoleList] = useState([])
    const [secondaryReportingManagerList, setSecondaryReportingManagerList] = useState([])
    const [bankList, setBankList] = useState([])
    const [createDisabled, setCreateDisabled] = useState(false)
    const [localityList, setLocalityList] = useState([])
    const [loading, setLoading] = useState(false)
    const [is_edit] = useState(user_detail && user_detail.user_id && user_detail.user_id !== "" ? true : false)
    const [designationList, setDesignationList] = useState([])
    const [sources, setSources] = useState([]);
    const historyLead = useNavigate();

    useEffect(() => {
        if (ConfigList.length === 0) {
            props.handleReset()
            if (is_edit) {
                // historyLead("role_details?=" + userDetail.user_id);
                historyLead("/edit-user/role_details?=" + userDetail.user_id);
            } else {
                // historyLead("role_details");
                historyLead("/add-user/role_details");
            }
        }
        getRoleList()
        getUsersByRole()
        getReportingRole()
        getBankList()
        getReferralUserList()
        getLocalityList()
        getDesignationList()
        if (userDetail.user_id_hash) {
            getUserLocationDetail(userDetail.user_id_hash)
        }
        if(TENANT !== TENANTS.PH){
            getSources()
        }
        else{
            setSources([]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps       
    }, [])

    const getUserLocationDetail = async (user_id) => {
        if (userDetail.role_details.city && userDetail.role_details.city.length > 0) {

        } else {
            setLoading(true);
            await MasterService.post('/sfa/user/get-user_location', { user_id }).then(async function (response) {
                if (response.data.status === 200) {
                    let data = response.data.data
                    let tempUserDetail = { ...userDetail };

                    let state_data = data.location_response.map(({ state_id }) => state_id)
                    state_data = state_data.filter((item, i, ar) => ar.indexOf(item) === i);
                    let city_data = data.location_response.map(({ city_id }) => city_id)
                    city_data = city_data.filter((item, i, ar) => ar.indexOf(item) === i);

                    tempUserDetail.role_details.state = state_data
                    tempUserDetail.role_details.city = city_data
                    setUserDetail(tempUserDetail)
                    setLoading(false)
                }else{
                    toast.error(response.data.message)
                    setLoading(false)
                }
            })
        }
    }

    const getLocalityList = async () => {
        await MasterService.post('/sfa/user/locality_list', { city: userDetail.basic_details.city }).then((res) => {
            let locality_list = res.data.data && res.data.data.length ? res.data.data.map(elm => ({ id: elm.id, label: elm.value || elm.locality_name || elm.name, value: elm.id })):[]
            setLocalityList(locality_list)
        }).catch(error=>{
        })
    }

    const getSources = async () => {
        try {
            let response = await MasterService.post('/sfa/user/get_sources_config', { role_id: user_detail.role_details.role });
            if (response && response.data && response.data.status === 200) {
                if(response.data.data){
                    setSources(response.data.data);
                }
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error(error)
        }
    }

    const getDesignationList = async () => {
        let occupation_id_data = (TENANT === TENANTS.PH)?[]:ConfigList.current_occupation.filter(e=>e.value === userDetail.basic_details.current_occupation)
        let occupation_id = occupation_id_data && occupation_id_data.length ? occupation_id_data[0].id : ""
        if (occupation_id) {
            MasterService.post('/sfa/user/designation-list', { occupation_id })
                .then(function (response) {
                    if (response.data.status === 200) {
                        var designation_list = response.data.data.map(elm => ({ id: elm.value, label: elm.label, value: elm.value }));
                        setDesignationList(designation_list);
                    }
                })
                .catch(function (response) {
                });
        }
    }

    const getReferralUserList = async () => {
        MasterService.post('/sfa/user/get_referral_user', {})
            .then(function (response) {
                if (response.data.status === 200) {
                    var referral_list = response.data.data.map(elm => ({ id: elm.id, label: elm.name + " (" + elm.id + ")", value: elm.id }));
                    setReferralName(referral_list);
                }
            })
            .catch(function (response) {
            });
    }

    const getBankList = async () => {
        MasterService.post('/sfa/user/bank-list', {})
            .then(function (response) {
                if (response.data.status === 200) {
                    var bank_list = response.data.data.filter(elm => elm.bankId === basic_details.bank_id);
                    setBankList(bank_list);
                }
            })
            .catch(function (response) {
            });
    }

    const getRoleList = async () => {
        MasterService.post('/sfa/user/role_list', {})
            .then(function (response) {
                if (response.data.status === 200) {
                    let role_list = response.data.data.filter(elm => elm.id === userDetail.role_details.role);
                    setRoleDetails(role_list)
                }
            })
            .catch(function (response) {
            });
    }

    const getUsersByRole = async () => {
        MasterService.post('/sfa/user/get-users', {
            role_id: userDetail.role_details.reporting_role,
            business_unit_id: userDetail.role_details.business_unit_id,
            search_text: String(userDetail.role_details.reporting_manager || ""),
            page_no: 1,
            page_limit: 500
        })
            .then(function (response) {
                if (response.data.status === 200) {
                    let reporting_manager_list = response.data.data.user_list.filter(elm => parseInt(elm.id) === parseInt(userDetail.role_details.reporting_manager));
                    setReportingManagerList(reporting_manager_list)
                }
            })
            .catch(function (response) {
            });
        if (validationForFields.secondary_reporting_div.includes(parseInt(userDetail.role_details.role)) &&
            validationForFields.secondary_reporting_div_business_line.includes(userDetail.role_details.business_line)) {
            MasterService.post('/sfa/user/get-users', {
                role_id: userDetail.role_details.secondary_reporting_role,
                business_unit_id: userDetail.role_details.business_unit_id,
                search_text: String(userDetail.role_details.secondary_reporting_manager || ""),
                page_no: 1,
                page_limit: 500
            })
                .then(function (response) {
                    if (response.data.status === 200) {
                        let secondary_reporting_manager_list = response.data.data.user_list.filter(elm => parseInt(elm.id) === parseInt(userDetail.role_details.secondary_reporting_manager));
                        setSecondaryReportingManagerList(secondary_reporting_manager_list)
                    }
                })
                .catch(function (response) {
                });
        }
    }
    const getReportingRole = async () => {
        MasterService.post('/sfa/user/reporting_role_list', { role_id: userDetail.role_details.role })
            .then(function (response) {
                if (response.data.status === 200) {
                    let reporting_role_list = response.data.data.filter(elm => elm.id === userDetail.role_details.reporting_role);
                    setReportingRoleList(reporting_role_list)
                    if (validationForFields.secondary_reporting_div.includes(parseInt(userDetail.role_details.role)) &&
                        validationForFields.secondary_reporting_div_business_line.includes(userDetail.role_details.business_line)) {
                        let secondary_reporting_role_list = response.data.data.filter(elm => elm.id === userDetail.role_details.secondary_reporting_role);
                        setSecondaryReportingRoleList(secondary_reporting_role_list)
                    }
                }
            })
            .catch(function (response) {
            });
    }

    const handleClickCancel = () => {
        if (user_detail?.user_id) {
            historyLead('/view-user/' + user_detail?.user_id_hash,  { replace: true })
        }
    }

    const handleClick = async () => {
        setCreateDisabled(true)
        let result = isValidate()
        if (result.formIsValid) {
            await props.handleCreateUser()
        } else {
            let pathname = ""
            if (result.basic_detail_error === "true") {
                if (is_edit) {
                    pathname = '/edit-user/basic_details'
                } else {
                    pathname = '/add-user/basic_details'
                }
            }
            if (result.role_error === "true") {
                if (is_edit) {
                    pathname = '/edit-user/role_details'
                } else {
                    pathname = '/add-user/role_details'
                }
            }
            if (result.document_error === "true") {
                if (is_edit) {
                    pathname = '/edit-user/documents'
                } else {
                    pathname = '/add-user/documents'
                }
            }

            if (is_edit) {
                historyLead(pathname + "?=" + userDetail.user_id_hash, { tempErrors: result.tempErrors });
            } else {
                historyLead(pathname, { tempErrors: result.tempErrors });
            }
        }
    }

    const isValidate = () => {
        let tempUserDetail = { ...userDetail };
        let formIsValid = true;
        let tempErrors = {};
        let role_error = "false"
        let basic_detail_error = "false"
        let document_error = "false"
        // if (is_edit && tempUserDetail.basic_details["password"] === defaultPassword) {
        //     tempUserDetail.basic_details["password"] = ""
        //     tempUserDetail.basic_details["confirm_password"] = ""
        // }

        if (!tempUserDetail.role_details["state"]) {
            formIsValid = false;
            role_error = "true";
            tempErrors["state"] = 'State is required';
        }
        if (!tempUserDetail.role_details["city"]) {
            formIsValid = false;
            role_error = "true";
            tempErrors["city"] = 'City is required';
        }
        if (!tempUserDetail.role_details["role"]) {
            formIsValid = false;
            role_error = "true";
            tempErrors["role"] = 'Role is required';
        }
        if (!tempUserDetail.role_details["reporting_role"] && tempUserDetail.role_details.role !== TOP_HIERARCHY_ROLE_ID) {
            formIsValid = false;
            role_error = "true";
            tempErrors["reporting_role"] = 'Reporting Role is required';
        }
        if (!tempUserDetail.role_details["reporting_manager"] && tempUserDetail.role_details.role !== TOP_HIERARCHY_ROLE_ID) {
            formIsValid = false;
            role_error = "true";
            tempErrors["reporting_manager"] = 'Reporting Manager is required';
        }

        // if (validationForFields.secondary_reporting_div.includes(parseInt(tempUserDetail.role_details.role)) &&
        //     validationForFields.secondary_reporting_div_business_line.includes(tempUserDetail.role_details.business_line)) {
        //     if (!tempUserDetail.role_details["secondary_reporting_role"]) {
        //         formIsValid = false;
        //         role_error = "true";
        //         tempErrors["secondary_reporting_role"] = 'Secondary Reporting Role is required';
        //     }
        //     if (!tempUserDetail.role_details["secondary_reporting_manager"]) {
        //         formIsValid = false;
        //         role_error = "true";
        //         tempErrors["secondary_reporting_manager"] = 'Secondary Reporting Manager is required';
        //     }
        // }

        if (!tempUserDetail.role_details["business_line"]) {
            formIsValid = false;
            role_error = "true";
            tempErrors["business_line"] = 'Business Line is required';
        }

        if (!tempUserDetail.basic_details["username"]) {
            formIsValid = false;
            basic_detail_error = "true";
            tempErrors["username"] = 'Username is required';
        }
        if (!tempUserDetail.basic_details["mobile_no"]) {
            formIsValid = false;
            basic_detail_error = "true";
            tempErrors["mobile_no"] = 'Mobile is required';
        } else if (tempUserDetail.basic_details["mobile_no"].length < 8) {
            formIsValid = false;
            tempErrors["mobile_no"] = 'Mobile length must be between 8 and 12';
        }
        else if (tempUserDetail.basic_details["mobile_no"].length > 12) {
            formIsValid = false;
            tempErrors["mobile_no"] = 'Mobile length must be between 8 and 12';
        }
        if(tempUserDetail.basic_details["alternative_number"] && tempUserDetail.basic_details["alternative_number"].trim().length > 0){
            if (tempUserDetail.basic_details["alternative_number"].length < 8) {
                formIsValid = false;
                tempErrors["alternative_number"] = 'Mobile length must be between 8 and 12';
            }
            else if (tempUserDetail.basic_details["alternative_number"].length > 12) {
                formIsValid = false;
                tempErrors["alternative_number"] = 'Mobile length must be between 8 and 12';
            }
        }
        if(tempUserDetail.basic_details["whatsapp_mobile_number"] && tempUserDetail.basic_details["whatsapp_mobile_number"].trim().length > 0){
            if (tempUserDetail.basic_details["whatsapp_mobile_number"].length < 8) {
                formIsValid = false;
                tempErrors["whatsapp_mobile_number"] = 'Mobile length must be between 8 and 12';
            }
            else if (tempUserDetail.basic_details["whatsapp_mobile_number"].length > 12) {
                formIsValid = false;
                tempErrors["whatsapp_mobile_number"] = 'Mobile length must be between 8 and 12';
            }
        }
        
        if (!tempUserDetail.basic_details["email_id"]) {
            formIsValid = false;
            basic_detail_error = "true";
            tempErrors["email_id"] = 'Email is required';
        }
        else if (tempUserDetail.basic_details["email_id"].match(EMAIL_VALIDATION) == null) {
            tempErrors["email_id"] = 'Email is not valid';
        }
        if (tempUserDetail.basic_details["npwp"]) {
            const npwpDigits = tempUserDetail.basic_details["npwp"].replace(/[^0-9]/g, "");
            if (npwpDigits.length < 15 || npwpDigits.length > 16) {
                tempErrors["npwp"] = 'NPWP is not valid';
            }
        }
        if(TENANT === TENANTS.PH){

        }else{
            if (!tempUserDetail.basic_details["ktp_id"]) {
                formIsValid = false;
                tempErrors["ktp_id"] = 'KTP ID is required';
            } else if (isNaN(tempUserDetail.basic_details["ktp_id"])) {
                formIsValid = false;
                tempErrors["ktp_id"] = 'KTP ID must be numeric';
            }
        }
        
        if (!tempUserDetail.basic_details["joining_date"]) {
            formIsValid = false;
            basic_detail_error = "true";
            tempErrors["joining_date"] = 'Joining Date is required';
        }
        if (!tempUserDetail.basic_details["employment_type"]) {
            formIsValid = false;
            basic_detail_error = "true";
            tempErrors["employment_type"] = 'Employment Type is required';
        }
        if (parseInt(tempUserDetail.basic_details["employment_type"]) === 1 && !tempUserDetail.basic_details["employee_id"]) {
            formIsValid = false;
            basic_detail_error = "true";
            tempErrors["employee_id"] = 'Employee Id is required';
        }
        if (!tempUserDetail.basic_details["bank_id"]) {
            formIsValid = false;
            tempErrors["bank_id"] = 'Bank Name is required';
        }
        if (!tempUserDetail.basic_details["bank_branch_name"]) {
            formIsValid = false;
            basic_detail_error = "true";
            tempErrors["bank_branch_name"] = 'Branch is required';
        }
        if (!tempUserDetail.basic_details["bank_account_number"]) {
            formIsValid = false;
            basic_detail_error = "true";
            tempErrors["bank_account_number"] = 'Account Number is required';
        } else {
            let account_length = bankList.length ? bankList[0].valid_length : 0
            if (tempUserDetail.basic_details["bank_account_number"].length < account_length && account_length > 0) {
                tempErrors["bank_account_number"] = 'Format of Account Number must '+account_length+' digits';
            }
        }
        if (!tempUserDetail.basic_details["beneficiary_name"]) {
            formIsValid = false;
            basic_detail_error = "true";
            tempErrors["beneficiary_name"] = 'Beneficiary Name is required';
        }
        if (!tempUserDetail.basic_details["date_of_birth"]) {
            formIsValid = false;
            basic_detail_error = "true";
            tempErrors["date_of_birth"] = 'DOB is required';
        }
        if (!tempUserDetail.basic_details["state_name"]) {
            formIsValid = false;
            basic_detail_error = "true";
            tempErrors["state"] = 'State is required';
        }
        if (!tempUserDetail.basic_details["city"]) {
            formIsValid = false;
            basic_detail_error = "true";
            tempErrors["city"] = 'City is required';
        }
        if (!tempUserDetail.basic_details["postal_code"]) {
            formIsValid = false;
            basic_detail_error = "true";
            tempErrors["postal_code"] = 'Postal Code is required';
        }
        if (!tempUserDetail.basic_details["current_occupation"] && validationForFields.current_occupation.includes(tempUserDetail.role_details.role)) {
            formIsValid = false;
            basic_detail_error = "true";
            tempErrors["current_occupation"] = 'Current Occupation is required';
        }
        // if (!tempUserDetail.basic_details["company_name"] && validationForFields.company_name.includes(tempUserDetail.role_details.role) && parseInt(tempUserDetail.role_details.role) === parseInt(Role.Agent)) {
        //     formIsValid = false;
        //     basic_detail_error = "true";
        //     tempErrors["company_name"] = 'Company Name is required';
        // }
        if (!tempUserDetail.basic_details["designation"] && validationForFields.designation.includes(tempUserDetail.role_details.role)) {
            formIsValid = false;
            basic_detail_error = "true";
            tempErrors["designation"] = 'Designation is required';
        }
        if([TENANTS.OTO, TENANTS.FAV].includes(TENANT) && tempUserDetail.role_details?.business_vertical_id === HRF_BUSINESS_VERTICAL_ID){
            validationForFields.tagging =  TENANT === TENANTS.OTO ? [Role.Agent] : [Role.MO];
        }
        if (!tempUserDetail.basic_details["tagging_id"] && validationForFields.tagging.includes(tempUserDetail.role_details.role)) {
            formIsValid = false;
            tempErrors["tagging_id"] = 'Tagging is required';
        } else if (showPhSalesOfficerTaggingField(tempUserDetail.role_details.role, ConfigList?.tagging_roles, tempUserDetail.role_details?.business_vertical_id) && !tempUserDetail.basic_details["tagging_id"]) {
            formIsValid = false;
            tempErrors["tagging_id"] = 'Tagging is required';
        } else if(tempUserDetail.basic_details["tagging_id"] === "eca" && (!tempUserDetail.basic_details["eca_agent"] || Object.keys(tempUserDetail.basic_details["eca_agent"]).length === 0)){
            tempErrors["eca_agent"] = 'Referral Agent is required';
        }
        if (!tempUserDetail.basic_details["source"] && validationForFields.source.includes(tempUserDetail.role_details.role)) {
            formIsValid = false;
            basic_detail_error = "true";
            tempErrors["source"] = 'Source is required';
        }
        // if (!tempUserDetail.basic_details["referral_name"] && validationForFields.referral_name.includes(tempUserDetail.role_details.role)) {
        //     formIsValid = false;
        //     basic_detail_error = "true";
        //     tempErrors["referral_name"] = 'Referral Name is required';
        // }
        

        // if (!is_edit && !tempUserDetail.basic_details["password"]) {
        //     formIsValid = false;
        //     basic_detail_error = "true";
        //     tempErrors["password"] = 'Password is required';
        // }
        // if (!is_edit && !tempUserDetail.basic_details["confirm_password"]) {
        //     formIsValid = false;
        //     basic_detail_error = "true";
        //     tempErrors["confirm_password"] = 'Confirm Password is required';
        // }
        // if (!(tempUserDetail.basic_details["password"] === "" && tempUserDetail.basic_details["confirm_password"] === "") && tempUserDetail.basic_details["confirm_password"] !== tempUserDetail.basic_details["password"]) {
        //     formIsValid = false;
        //     basic_detail_error = "true";
        //     tempErrors["confirm_password"] = 'Password does not match ';
        // }

        for (let index = 0; index < userDetail.documents.length; index++) {
            const element = userDetail.documents[index];
            let config_doc = ConfigList.document.filter(e => e.id === element.document_id)
            if (element.doc_url === "" && config_doc[0].doc_required) {
                formIsValid = false
                document_error = "true"
                let doc_title = config_doc[0].doc_title
                tempErrors[doc_title] = doc_title + " is required"
            }
        }

        if (Object.keys(tempErrors).length > 0) {
            formIsValid = false
        }
        let response = {
            formIsValid: formIsValid,
            basic_detail_error: basic_detail_error,
            tempErrors: tempErrors,
            role_error: role_error,
            document_error: document_error
        }
        return response;
    }

    const handleEdit = (pathname) => {
        let url = ""
        if (is_edit) {
            url = "/edit-user/" + pathname + "?=" + userDetail.user_id
            historyLead(url);
        } else {
            url = "/add-user/" + pathname
            historyLead(url);
        }
    }
    let { role_details, basic_details, documents } = userDetail
  

    const selectedBusinessValue = TENANT === TENANTS.PH ? Business.find(item => item.id === 1)?.value: Business.find(  item => item.id === role_details?.business_unit_id )?.value;
    const selectedBusinessVerticalValue =  Vertical.find(item => item.id === role_details?.business_vertical_id )?.value ?? "Unknown";

    
    return (
        <React.Fragment>
            <div className='preview-confirmation p-xxl add-user-detail-filed'>
                {loading ? <Loader /> : null}
                <div className='top-heading d-flex'>
                    <h2>Role Details</h2>
                    <a href={() => false} onClick={() => handleEdit("role_details")} className='edit-opt'>Edit</a>
                </div>

                <div className='d-flex'>
                    <div className='role-detail-preview'>
                        <h3>Business Vertical</h3>
                        <ul>
                            <li>
                                <span>Business</span>                                
                                <label>{selectedBusinessValue}</label>
                            </li>
                            <li>
                                <span>Vertical</span>
                                <label>{selectedBusinessVerticalValue}</label>
                            </li>
                        </ul>
                    </div>
                    <div className='role-detail-preview'>
                        <h3>Map Region</h3>
                        <ul>
                            {/* {role_details.zone_id && */}
                            <li>
                                <span>Zone</span>
                                <label>{Zone.filter(e => e.id === defaultZone)[0].label}</label>

                            </li>
                            {/* } */}
                            {role_details.state &&
                                <li>
                                    <span>State</span>
                                    <label>{role_details.state ? role_details.state.length : "No"} States</label>
                                </li>
                            }
                            {role_details.city &&
                                <li>
                                    <span>City</span>
                                    <label>{role_details.city ? role_details.city.length : "No"} Cities</label>
                                </li>
                            }
                        </ul>
                    </div>
                </div>

                <div className='d-flex m-xl-t p-sm-t br-bottom preview-basic-details'>
                    <div className='role-detail-preview'>
                        <h3>Role and Reporting</h3>
                        <ul>
                            {roleList && roleList.length > 0 &&
                                <li>
                                    <span>Role</span>
                                    <label>{roleList[0].name}</label>
                                </li>
                            }
                            {role_details.business_line && ConfigList && ConfigList.business_line && ConfigList.business_line.length > 0 && ConfigList.business_line.findIndex(e => e.value === role_details.business_line) > -1 &&
                                <li>
                                    <span>Business Line</span>
                                    <label>{ConfigList.business_line.findIndex(e => e.value === role_details.business_line) > -1 ? ConfigList.business_line.filter(e => e.value === role_details.business_line)[0].label : ""}</label>
                                </li>
                            }
                            {reportingRoleList.length > 0 &&
                                <li>
                                    <span>Primary Reporting Role</span>
                                    <label>{reportingRoleList[0].name}</label>
                                </li>
                            }
                            {reportingManagerList.length > 0 &&
                                <li>
                                    <span>Primary Reporting Manager</span>
                                    <label>{reportingManagerList[0].name}</label>
                                </li>
                            }
                            {(TENANT===TENANTS.OTO || TENANT===TENANTS.TRIV) && secondaryReportingRoleList.length > 0 &&
                                <li>
                                    <span>Secondary Reporting Role</span>
                                    <label>{secondaryReportingRoleList[0].name}</label>
                                </li>
                            }
                            {(TENANT===TENANTS.OTO || TENANT===TENANTS.TRIV) && secondaryReportingManagerList.length > 0 &&
                                <li>
                                    <span>Secondary Reporting Manager</span>
                                    <label>{secondaryReportingManagerList[0].name}</label>
                                </li>
                            }
                        </ul>
                    </div>
                </div>


                <div className='top-heading d-flex'>
                    <h2>Basic Details</h2>
                    <a href={() => false} onClick={() => handleEdit("basic_details")} className='edit-opt'>Edit</a>
                </div>
                <div className='d-flex'>
                    <div className='role-detail-preview'>
                        <h3>Profile Photo</h3>
                        <div className='profile-photo'>
                            {basic_details.profile_image && basic_details.profile_image !== "" ?
                                <img src={basic_details.profile_image} className="" alt="no pic" /> :
                                <label>No Image</label>
                            }
                        </div>
                    </div>
                    <div className='role-detail-preview preview-basic-details'>
                        <h3>Personal Detail</h3>
                        <ul>
                            {basic_details.username &&
                                <li>
                                    <span>Username</span>
                                    <label>{basic_details.username}</label>
                                </li>
                            }
                            {basic_details.mobile_no &&
                                <li>
                                    <span>Mobile</span>
                                    <label>{basic_details.mobile_no}</label>
                                </li>
                            }
                            {basic_details.email_id &&
                                <li>
                                    <span>Email</span>
                                    <label>{basic_details.email_id}</label>
                                </li>
                            }
                            {basic_details.ktp_id &&
                                <li>
                                    <span>KTP ID</span>
                                    <label>{basic_details.ktp_id}</label>
                                </li>
                            }
                            {basic_details.employment_type &&
                                <li>
                                    <span>Employment Type</span>
                                    <label>{EmploymentType.findIndex(e => e.value === basic_details.employment_type) > -1 ? EmploymentType.filter(e => e.value === basic_details.employment_type)[0].label : "NA"}</label>
                                </li>
                            }
                            {basic_details.employee_id &&
                                <li>
                                    <span>Employee ID</span>
                                    <label title={basic_details.employee_id}>{basic_details.employee_id}</label>
                                </li>
                            }
                            {basic_details.joining_date && isNaN(Date.parse(basic_details.joining_date)) === false &&
                                <li>
                                    <span>Joining Date</span>
                                    <label>{new Date(basic_details.joining_date).toISOString().split('T')[0]}</label>
                                </li>
                            }
                            {basic_details.anniversary_date && isNaN(Date.parse(basic_details.anniversary_date)) === false &&
                                <li>
                                    <span>Anniversary</span>
                                    <label>{new Date(basic_details.anniversary_date).toISOString().split('T')[0]}</label>
                                </li>
                            }
                            {basic_details.whatsapp_mobile_number &&
                                <li>
                                    <span>Whatsapp Mobile Number</span>
                                    <label>{basic_details.whatsapp_mobile_number}</label>
                                </li>
                            }
                            {basic_details.alternative_number && TENANT !== TENANTS.PH &&
                                <li>
                                    <span>Alternative Number</span>
                                    <label>{basic_details.alternative_number}</label>
                                </li>
                            }
                        </ul>
                    </div>
                </div>
                <div className='d-flex  p-sm-t'>
                    <div className='role-detail-preview preview-basic-details'>
                        <h3>Bank Details</h3>
                        <ul>
                            {bankList.length > 0 &&
                                <li>
                                    <span>Bank Name</span>
                                    <label>{bankList[0].bankName}</label>
                                </li>
                            }
                            {basic_details.bank_branch_name &&
                                <li>
                                    <span>Branch</span>
                                    <label>{basic_details.bank_branch_name}</label>
                                </li>
                            }
                            {basic_details.bank_account_number &&
                                <li>
                                    <span>Account Number</span>
                                    <label>{basic_details.bank_account_number}</label>
                                </li>
                            }
                            {basic_details.beneficiary_name &&
                                <li>
                                    <span>Beneficiary Name</span>
                                    <label>{basic_details.beneficiary_name}</label>
                                </li>
                            }
                            {basic_details.npwp && TENANT !== TENANTS.PH &&
                                <li>
                                    <span>NPWP</span>
                                    <label>{basic_details.npwp}</label>
                                </li>
                            }
                        </ul>
                    </div>
                </div>

                <div className='d-flex  p-sm-t'>
                    <div className='role-detail-preview preview-basic-details'>
                        <h3>Other Details</h3>
                        <ul>
                            {basic_details.date_of_birth && isNaN(Date.parse(basic_details.date_of_birth)) === false &&
                                <li>
                                    <span>DOB</span>
                                    <label>{new Date(basic_details.date_of_birth).toISOString().split('T')[0]}</label>
                                </li>
                            }
                            {basic_details.state_name && stateList.length > 0 && stateList.findIndex(e => e.id === basic_details.state_name) > -1 &&
                                <li>
                                    <span>State</span>
                                    <label>{stateList.findIndex(e => e.id === basic_details.state_name) > -1 ? stateList.filter(e => e.id === basic_details.state_name)[0].label : ""}</label>
                                </li>
                            }
                            {basic_details.city && cityList.length > 0 && cityList.findIndex(e => e.id === basic_details.city) > -1 &&
                                <li>
                                    <span>City</span>
                                    <label>{cityList.findIndex(e => e.id === basic_details.city) > -1 ? cityList.filter(e => e.id === basic_details.city)[0].label : ""}</label>
                                </li>
                            }
                            {basic_details.user_location !== 0 && localityList.length > 0 &&
                                <li>
                                    <span>Locality</span>
                                    <label>{localityList.findIndex(e => e.id === basic_details.user_location) > -1 ? localityList.filter(e => e.id === basic_details.user_location)[0].label : ""}</label>
                                </li>
                            }
                            {basic_details.current_occupation && ConfigList.current_occupation.findIndex(e => e.value === basic_details.current_occupation) > -1 &&
                                <li>
                                    <span>Current Occupation</span>
                                    <label>{ConfigList.current_occupation.findIndex(e => e.value === basic_details.current_occupation) > -1 ? ConfigList.current_occupation.filter(e => e.value === basic_details.current_occupation)[0].label : ""}</label>
                                </li>
                            }
                            {basic_details.designation && designationList.findIndex(e => e.value === basic_details.designation) > -1 &&
                                <li>
                                    <span>Designation</span>
                                    <label>{designationList.findIndex(e => e.value === basic_details.designation) > -1 ? designationList.filter(e => e.value === basic_details.designation)[0].label : ""}</label>
                                </li>
                            }
                            {showPhSalesOfficerTaggingDisplay(role_details.role, basic_details.tagging_id) &&
                                <li>
                                    <span>Tagging</span>
                                    <label>{getTaggingLabel(basic_details.tagging_id, ConfigList?.tagging_roles)}</label>
                                </li>
                            }
                            {basic_details.tagging_id && ConfigList && ConfigList.tagging_roles && ConfigList.tagging_roles.length > 0 && ConfigList.tagging_roles.findIndex(e => e.value === basic_details.tagging_id) > -1 &&
                                <li>
                                    <span>Tagging</span>
                                    <label>{ConfigList.tagging_roles.findIndex(e => e.value === basic_details.tagging_id) > -1 ? ConfigList.tagging_roles.filter(e => e.value === basic_details.tagging_id)[0].label : ""}</label>
                                </li>
                            }  
                            {/* {basic_details.tagging_id == "eca" && basic_details.tagging_level && ConfigList && ConfigList.tagging_level && ConfigList.tagging_roles.length > 0 && ConfigList.tagging_level.findIndex(e => e.value === basic_details.tagging_level_id) > -1 &&
                                <li>
                                    <span>Level</span>
                                    <label>{ConfigList.tagging_level.findIndex(e => e.value === basic_details.tagging_level_id) > -1 ? ConfigList.tagging_level.filter(e => e.value === basic_details.tagging_level_id)[0].label : ""}</label>
                                </li>
                            }        */}                     
                            {basic_details.source && sources.findIndex(e => e.value === basic_details.source) > -1 &&
                                <li>
                                    <span>Source</span>
                                    <label>{sources.findIndex(e => e.value === basic_details.source) > -1 ? sources.filter(e => e.value === basic_details.source)[0].label : ""}</label>
                                </li>
                            }
                            {basic_details.postal_code &&
                                <li>
                                    <span>Postal Code</span>
                                    <label>{basic_details.postal_code}</label>
                                </li>
                            }
                            {basic_details.house_number &&
                                <li>
                                    <span>House No.</span>
                                    <label>{basic_details.house_number}</label>
                                </li>
                            }
                            {basic_details.rt &&
                                <li>
                                    <span>RT</span>
                                    <label>{basic_details.rt}</label>
                                </li>
                            }
                            {basic_details.rw &&
                                <li>
                                    <span>RW</span>
                                    <label>{basic_details.rw}</label>
                                </li>
                            }
                            {/* {basic_details.street_address &&
                                <li>
                                    <span>Street Address</span>
                                    <label>{basic_details.street_address}</label>
                                </li>
                            } */}
                            {basic_details.incentive_percentage > 0 &&
                                <li>
                                    <span>Incentive%</span>
                                    <label>{basic_details.incentive_percentage}</label>
                                </li>
                            }
                            {basic_details.address &&
                                <li className='address-txt'>
                                    <span>Address</span>
                                    <label>{basic_details.address}</label>
                                </li>
                            }
                            {((TENANT===TENANTS.OTO || TENANT===TENANTS.TRIV) ? (role_details.role === Role.AM) : (role_details.role === Role.RM)) &&
                                <li>
                                    <span>Tax Booster Enable</span>
                                    <label>{basic_details.is_tax_booster_enable === true ? "Yes" : "No"}</label>
                                </li>
                            }
                            {TENANT !== TENANTS.PH &&
                            <li>
                                <span>{(TENANT===TENANTS.OTO || TENANT===TENANTS.TRIV) ? "BM Grading" : "MM Grading" }</span>
                                <label>{ConfigList.bm_grading.findIndex(e => e.value === basic_details.bm_grading) > -1 ? ConfigList.bm_grading.filter(e => e.value === basic_details.bm_grading)[0].label : "-"}</label>
                            </li>
                            }
                            {basic_details.company_name &&
                                <li>
                                    <span>Company Name</span>
                                    <label title={basic_details.company_name?basic_details.company_name:""}>{basic_details.company_name}</label>
                                </li>
                            }
                            {basic_details.company_address &&
                                <li>
                                    <span>Company Address</span>
                                    <label title={basic_details.company_address?basic_details.company_address:""}>{basic_details.company_address}</label>
                                </li>
                            }
                        </ul>
                    </div>
                </div>

                {is_edit &&
                    <div className='d-flex  p-sm-t'>
                        <div className='role-detail-preview preview-basic-details'>
                            <h3>Additional Details</h3>
                            <ul>
                                {basic_details.created_date && isNaN(Date.parse(basic_details.created_date)) === false &&
                                    <li>
                                        <span>Created Date</span>
                                        <label>{new Date(basic_details.created_date).toISOString().split('T')[0]}</label>
                                    </li>
                                }
                                {basic_details.approval_date && isNaN(Date.parse(basic_details.approval_date)) === false &&
                                    <li>
                                        <span>Approval Date</span>
                                        <label>{new Date(basic_details.approval_date).toISOString().split('T')[0]}</label>
                                    </li>
                                }
                                {TENANT !== TENANTS.PH && basic_details.approved_by_admin_name &&
                                    <li>
                                        <span>Approved By</span>
                                        <label>{basic_details.approved_by_admin_name}</label>
                                    </li>
                                }
                                {basic_details.onboarded_from &&
                                    <li>
                                        <span>Onboarded From</span>
                                        <label>{basic_details.onboarded_from}</label>
                                    </li>
                                }
                                {basic_details.onboarded_by &&
                                    <li>
                                        <span>Onboarded By</span>
                                        <label>{basic_details.onboarded_by}</label>
                                    </li>
                                }
                                {TENANT === TENANTS.PH && basic_details.warning_date_1 && isNaN(Date.parse(basic_details.warning_date_1)) === false &&
                                    <li>
                                        <span>Warning Date 1</span>
                                        <label>{new Date(basic_details.warning_date_1).toISOString().split('T')[0]}</label>
                                    </li>
                                }
                                {TENANT === TENANTS.PH && basic_details.warning_date_2 && isNaN(Date.parse(basic_details.warning_date_2)) === false &&
                                    <li>
                                        <span>Warning Date 2</span>
                                        <label>{new Date(basic_details.warning_date_2).toISOString().split('T')[0]}</label>
                                    </li>
                                }
                                {basic_details.resign_date_1 && isNaN(Date.parse(basic_details.resign_date_1)) === false &&
                                    <li>
                                        <span>Resign Date 1</span>
                                        <label>{new Date(basic_details.resign_date_1).toISOString().split('T')[0]}</label>
                                    </li>
                                }
                                {basic_details.resign_date_2 && isNaN(Date.parse(basic_details.resign_date_2)) === false &&
                                    <li>
                                        <span>Resign Date 2</span>
                                        <label>{new Date(basic_details.resign_date_2).toISOString().split('T')[0]}</label>
                                    </li>
                                }
                                {basic_details.rejoin_date_1 && isNaN(Date.parse(basic_details.rejoin_date_1)) === false &&
                                    <li>
                                        <span>Rejoin Date 1</span>
                                        <label>{new Date(basic_details.rejoin_date_1).toISOString().split('T')[0]}</label>
                                    </li>
                                }
                                {basic_details.rejoin_date_2 && isNaN(Date.parse(basic_details.rejoin_date_2)) === false &&
                                    <li>
                                        <span>Rejoin Date 2</span>
                                        <label>{new Date(basic_details.rejoin_date_2).toISOString().split('T')[0]}</label>
                                    </li>
                                }

                                {basic_details.hiring_source && BasicDetailConfig.hiring_source.findIndex(e => e.value === basic_details.hiring_source) > -1 &&
                                    <li>
                                        <span>Hiring Source</span>
                                        <label>{BasicDetailConfig.hiring_source.findIndex(e => e.value === basic_details.hiring_source) > -1 ? BasicDetailConfig.hiring_source.filter(e => e.value === basic_details.hiring_source)[0].label : ""}</label>
                                    </li>
                                }

                                {basic_details.comments &&
                                    <li>
                                        <span>Comments</span>
                                        <label>{basic_details.comments}</label>
                                    </li>
                                }
                                {TENANT !== TENANTS.PH && (
                                    <li>
                                        <span>Inactivated By</span>
                                        <label>{basic_details.inactive_by_name ? basic_details.inactive_by_name : "-"}</label>
                                    </li>
                                )}
                                {TENANT !== TENANTS.PH && basic_details.inactive_date && isNaN(Date.parse(basic_details.inactive_date)) === false &&
                                    <li>
                                        <span>Inactive Date</span>
                                        <label>{new Date(basic_details.inactive_date).toISOString().split('T')[0]}</label>
                                    </li>
                                }
                                {TENANT !== TENANTS.PH && ((TENANT===TENANTS.OTO || TENANT===TENANTS.TRIV) ? (role_details.role === Role.Agent) : (role_details.role === Role.FA)) &&
                                    <li>
                                        <span>Manager Status</span>
                                        <label>{basic_details.manager_status ? basic_details.manager_status : "-"}</label>
                                    </li>
                                }

                            </ul>
                        </div>
                    </div>
                }

                {(TENANT === TENANTS.OTO || TENANT === TENANTS.FAV) && userDetail?.role_details?.business_vertical_id === HRF_BUSINESS_VERTICAL_ID && (!isEmpty(userDetail.basic_details.tagging_id)) ?
                    <>
                        <h3>Property Broker</h3>
                        <HrfDocumentSection
                            editable={false}
                            configList={ConfigList}
                            basic_details={userDetail.basic_details}
                        />
                    </>
                    : null
                }

                
                { is_edit && userDetail.basic_details.show_cbi_info && userDetail?.role_details?.business_vertical_id !== HRF_BUSINESS_VERTICAL_ID ? 
                <>
                 <h3>CBI Credit Information</h3>
                 <CbiCreditInformation
                    editable={false}
                    configList={ConfigList}
                    basic_details={userDetail.basic_details}
                /> 
                </>
                : null }

                <div className='d-flex  p-sm-t'>
                    {/* <div className='role-detail-preview preview-basic-details'>
                        <h3>Set Password</h3>
                        <ul>
                            <li>
                                <span>Password</span>
                                <label>{basic_details.password ? basic_details.password.replace(/./g, '*') : ""}</label>
                            </li>
                        </ul>
                    </div> */}
                    {validationForFields.referral_name.includes(userDetail.role_details.role) && ReferralName.length > 0 && basic_details.referral_name !== 0 &&
                        <div className='role-detail-preview'>
                            <h3>Reference</h3>
                            <ul>
                                <li>
                                    <span>Reference Name & ID</span>
                                    <label>{ReferralName.findIndex(e => e.id === basic_details.referral_name) > -1 ? ReferralName.filter(e => e.id === basic_details.referral_name)[0].label : ""}</label>
                                </li>
                            </ul>
                        </div>
                    }
                </div>
                {(TENANT===TENANTS.OTO) && userDetail?.role_details?.business_vertical_id !== HRF_BUSINESS_VERTICAL_ID &&
                    <div className='d-flex  p-sm-t br-bottom'>
                        <div className='role-detail-preview'>
                            <h3>Dealer Inventory Funding</h3>
                            <li className="custom-control custom-checkbox">
                                <span>Dealer Inventory Funding Subscribe: </span>
                                <input
                                    id={`is_subscribe_dif`}
                                    type="checkbox"
                                    name="is_subscribe_dif"
                                    className="custom-control-input"
                                    checked={basic_details.is_subscribe_dif ? true : false}
                                />

                                <label htmlFor={`is_subscribe_dif`} className="custom-control-label">
                                </label>
                            </li>
                        </div>
                    </div>
                }

                <div className='top-heading d-flex'>
                    <h2>Documents</h2>
                    <a href={() => false} onClick={() => handleEdit("documents")} className='edit-opt'>Edit</a>
                </div>

                <div className='d-flex'>
                    <div className='role-detail-preview doc-preview-details' style={{ display: "flex" }}>
                        {ConfigList && ConfigList.document && ConfigList.document?.length > 0 && documents && documents?.length > 0 && documents.map((data, index) => (
                            <div key={index} className='upload-document-outer'>
                                {data.doc_url !== "" &&
                                    <div className="img-bx-select-opt">
                                        <div className="image-bx">
                                            <img src={data.doc_url} className="" alt="no_image" />
                                        </div>
                                        <span className='document-name'>{ConfigList.document.filter(e => parseInt(e.id) === data.document_id)[0].doc_title}</span>
                                        {/* {data.is_doc_verified ? <span className='document-name'>Verified</span> :
                                            <span className='document-name error show'>Not Verified</span>} */}
                                    </div>
                                }
                            </div>
                        ))}
                    </div>
                </div>


                <div className='br-top-flex'>
                    {is_edit ? <div className="t-right">
                        <button className='btn-line m-xs-l' onClick={handleClickCancel.bind(this)}>
                            Cancel
                        </button>
                    </div> : null}
                    <div className="t-right">
                        <button disabled={createDisabled} className='btn-primary' onClick={handleClick.bind(this)}>
                            {is_edit ? "Update User" : "Create User"}
                        </button>
                    </div>
                </div>



            </div>

        </React.Fragment>
    )
}
export default PreviewConfirm;